import axios from 'axios'
import { Notify } from 'vant';

const baseUrl = process.env.VUE_APP_API_URL || "/lxz/api"

function getToken() {
    return localStorage.getItem('token') || ''
}

function clearAuthAndRedirectLogin() {
    localStorage.removeItem('token')
    localStorage.removeItem('user')
    const loginPath = '/login'
    if (window.location.hash.replace(/^#/, '') !== loginPath) {
        window.location.hash = loginPath
    }
}

function buildAuthHeaders(contentType) {
    const headers = {}
    if (contentType) {
        headers['Content-Type'] = contentType
    }
    const token = getToken()
    if (token) {
        headers.Authorization = `Bearer ${token}`
    }
    return headers
}

function handleUnauthorized(error) {
    if (error?.response?.status === 401) {
        clearAuthAndRedirectLogin()
    }
    return Promise.reject(error)
}

function request(param) {
    return new Promise((resolve, reject) => {
        axios({
            url: baseUrl + param.url,
            method: param.method,
            headers: buildAuthHeaders('application/json'),
            data: param.data,
            timeout: param.timeout || 60000,
        })
            .then(res => {
                if (res?.status === 401) {
                    clearAuthAndRedirectLogin()
                    reject(res)
                    return
                }
                if (res?.data?.error === -1) {
                    Notify(res?.data?.message)
                } else {
                    resolve(res)
                }
            })
            .catch(err => {
                handleUnauthorized(err).catch(reject)
            })
    })
}

function requestFile(param) {
    return new Promise((resolve, reject) => {
        axios({
            url: baseUrl + param.url,
            method: param.method,
            headers: buildAuthHeaders('multipart/form-data'),
            data: param.data
        })
            .then(res => {
                if (res?.status === 401) {
                    clearAuthAndRedirectLogin()
                    reject(res)
                    return
                }
                if (res?.data?.error === -1) {
                    Notify(res?.data?.message)
                } else {
                    resolve(res)
                }
            })
            .catch(err => {
                handleUnauthorized(err).catch(reject)
            })
    })
}

export default {
    request: request,
    requestFile: requestFile
}
